import React from "react";
import { Box } from "@chakra-ui/react";
import Navbar from "./navbar";
//import Sidebar from "../components/Sidebar";
import { Route, Routes } from "react-router-dom";
import Cookie from 'js-cookie';
import Login from '../modules/auth/Login/Login'
import { KotProvider } from "../modules/context/kotContext.js";
import { TableTimeProvider } from "../modules/context/tableTimeContext.js";
import { BillItemsProvider } from "../modules/context/tableItemsContext.js";
import Dashboard from "../modules/dashboard/index.js";
import TableStatus from '../modules/Table/tableStatus.js'
import QuickBill from '../modules/food/quickBillData.js'
import DailySalesSummary from "../modules/food/dailyLedger.js";
const Layout = () => {
  const token = Cookie.get('token');
  

  return (
   
      <Box width='full' h='full'>
        <Box display="flex">
         
          <Box display='flex' flexDirection='column' flexGrow={1} overflow='hidden'>
         
            {token && <Navbar />}
            <Box overflowY='auto' flexGrow={1}>
            <BillItemsProvider>
            <KotProvider>
            <TableTimeProvider>
           
                    <Routes>
                    

                     

                      {token ? (
                        <>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/table-status" element={<TableStatus />} />
                        <Route path="/quickBill" element={<QuickBill />} />
                        <Route path="/dailyLedger" element={<DailySalesSummary />} />
                          
                          {/* <Route path="/table-status" element={<TableStatus />} />
                          
                          <Route path="/dashboard" element={<Dashboard />} />
                          <Route path="/summary" element={<Summary />} /> */}
                          
                          
                        </>
                      ) : (
                        <>
                        <Route path="/login" element={<Login />} />
                        <Route path="*" element={<Login />} />
                        
                          {/* <Route path="/forgot-password" element={<ForgotPassword />} />
                          <Route path="/generate-otp" element={<GenerateOtp />} /> */}
                        </>
                      )}
                      
                    </Routes>
                    </TableTimeProvider>
                      </KotProvider>
                      </BillItemsProvider>
                
            </Box>
          </Box>
        </Box>
        
      </Box>
   
  );
};

export default Layout;
